import classnames from 'classnames';
import * as React from 'react';
import { createElement } from 'react';
import InputItem from '../input-item';
import { VerifyCodePropsType } from './PropsType';
import './style.less';
import CustomInput from './CustomInput';
function noop() { }
class VerifyCode extends React.Component {
    constructor(props) {
        super(props);
        this.countdown = () => {
            const { counter, countdowning } = this.state;
            const counterDefault = this.props.time;
            const counterDefault2 = counterDefault && counterDefault - 1;
            if (counter === 1) {
                this.setState({
                    counter: counterDefault,
                    countdowning: false,
                    buttonText: this.props.reBtnText || this.props.rightButtonText,
                });
                if (this.props.onTimerEnd) {
                    this.props.onTimerEnd();
                }
            }
            else {
                if (counter === counterDefault2 && countdowning === true) {
                    if (this.props.onTimerStart) {
                        this.props.onTimerStart();
                    }
                }
                this.setState({
                    counter: counter - 1,
                    countdowning: true,
                    buttonText: `${counter - 1}`,
                });
                if (this.props.onCountdown) {
                    this.props.onCountdown(counter - 1);
                }
                this.timer = setTimeout(this.countdown.bind(this), 1000);
            }
        };
        this.onInputChange = (e) => {
            const el = e.target;
            const { value: rawVal } = el;
            const { onChange, isReg } = this.props;
            if (isReg) {
                let prePos = 0;
                try {
                    prePos = el.selectionEnd || 0;
                }
                catch (error) {
                    console.warn('Get selection error:', error);
                }
                const { value: preCtrlVal = '' } = this.state;
                const ctrlValue = rawVal.replace(/\D/g, '');
                this.handleOnChange(ctrlValue, ctrlValue !== rawVal, () => {
                    try {
                        const pos = this.calcPos(prePos, preCtrlVal, rawVal, ctrlValue, [' '], /\D/g);
                        el.selectionStart = el.selectionEnd = pos;
                    }
                    catch (error) {
                        console.warn('Set selection error:', error);
                    }
                });
            }
            else if (onChange) {
                onChange(e.target.value);
            }
        };
        this.handleOnChange = (value, isMutated = false, adjustPos = noop) => {
            const { onChange } = this.props;
            console.log(this.inputRef);
            if (value.split('').length === 6) {
                if (this.inputRef) {
                    this.inputRef.onInputBlur(value);
                }
            }
            if (!('value' in this.props)) {
                this.setState({ value });
            }
            else {
                this.setState({ value: this.props.value });
            }
            if (onChange) {
                if (isMutated) {
                    setTimeout(() => {
                        onChange(value);
                        adjustPos();
                    });
                }
                else {
                    onChange(value);
                    adjustPos();
                }
            }
            else {
                adjustPos();
            }
        };
        this.onInputFocus = (value) => {
            this.setState({
                focus: true,
            });
            if (this.props.onFocus) {
                this.props.onFocus(value);
            }
        };
        this.onInputBlur = (value) => {
            if (this.props.onBlur) {
                setTimeout(() => {
                    if (document.body) {
                        document.body.scrollTop = document.body.scrollTop;
                    }
                }, 100);
                this.props.onBlur(value);
            }
        };
        this.calcPos = (prePos, preCtrlVal, rawVal, ctrlVal, placeholderChars, maskReg) => {
            const editLength = rawVal.length - preCtrlVal.length;
            const isAddition = editLength > 0;
            let pos = prePos;
            if (isAddition) {
                const additionStr = rawVal.substr(pos - editLength, editLength);
                let ctrlCharCount = additionStr.replace(maskReg, '').length;
                pos -= editLength - ctrlCharCount;
                let placeholderCharCount = 0;
                while (ctrlCharCount > 0) {
                    if (placeholderChars.indexOf(ctrlVal.charAt(pos - ctrlCharCount + placeholderCharCount)) === -1) {
                        ctrlCharCount--;
                    }
                    else {
                        placeholderCharCount++;
                    }
                }
                pos += placeholderCharCount;
            }
            return pos;
        };
        this.state = {
            buttonText: props.btnText || props.buttonText,
            countdowning: false,
            counter: props.time,
            time: props.time,
            value: props.value || '',
            loading: false,
        };
    }
    componentDidMount() {
        if (this.props.auto) {
            this.countdown();
            this.inputRef?.focus();
        }
    }
    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    static getDerivedStateFromProps(nextProps, state) {
        if (nextProps.isClearInterval || nextProps.clearInterval) {
            return {
                counter: nextProps.time,
                countdowning: false,
                buttonText: nextProps.btnText,
            };
        }
        if (nextProps.auto && nextProps.time !== state.time) {
            return {
                counter: nextProps.time,
                time: nextProps.time,
            };
        }
        else if (!state.countdowning && nextProps.time !== state.time) {
            return {
                counter: nextProps.time,
                time: nextProps.time,
            };
        }
        return null;
    }
    btnClick() {
        const { autoCountDown, btnDisabled } = this.props;
        if (btnDisabled) {
            return;
        }
        if (!autoCountDown) {
            if (this.state.loading)
                return;
            this.setState({
                loading: true
            });
        }
        if (this.props.onRightClick) {
            this.props.onRightClick();
        }
        else {
            this._beginCountDown();
        }
    }
    _beginCountDown(flag = true) {
        this.setState({
            loading: false
        });
        if (flag) {
            const { type } = this.props;
            if (type === 'number' || type === 'stress') {
                const { countdowning } = this.state;
                if (countdowning) {
                    return;
                }
                this.countdown();
                if (type == 'stress') {
                    this.inputRef?.focus();
                }
            }
        }
    }
    render() {
        const { className, prefixCls, type, title, titleWidth, textStyle, fontStyle, inputStyle, placeholder, tips, btnText, reBtnText, hideBottomLine, time, auto, maxLength, error, onTimerStart, onTimerEnd, onRightClick, rightComponent, rightConponentWidth, autoAdjustHeight, disabledKeys, disabled, keyboardType, timeTipText, showErrorInfo, errorInfo, inputAriaLabel, tipsAriaLabel, isTitleUp, ...restProps } = this.props;
        const attributeMap = {
            inputStyle: inputStyle || fontStyle,
        };
        const { buttonText, countdowning, loading } = this.state;
        const wrapCls = classnames(prefixCls, className);
        const buttonCls = classnames(`${prefixCls}-btn`, {
            [`${prefixCls}-btn-countdowning`]: countdowning,
            [`${prefixCls}-btn-loading`]: loading
        });
        const rightImgCls = classnames(`${prefixCls}-right-img`);
        if (type == 'stress') {
            const controlCls = classnames(`${prefixCls}-control`);
            const controlBtnCls = classnames(`${controlCls}-btn`, {
                [`${controlCls}-btn-countdowning`]: countdowning,
            });
            const { value } = this.state;
            return (createElement("div", { className: controlCls },
                createElement("div", { className: `${controlCls}-title` }, title),
                tips && countdowning ? (createElement("div", { className: `${controlCls}-tips` },
                    " ",
                    tips)) : null,
                createElement(CustomInput, { value: value, ref: el => (this.inputRef = el), onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, prefixCls: prefixCls, header: keyboardType !== 'inline', keyboardType: keyboardType, autoAdjustHeight: autoAdjustHeight, disabledKeys: disabledKeys, disabled: disabled }),
                createElement("div", { className: controlBtnCls },
                    createElement("div", { className: "error-info" }, showErrorInfo ? errorInfo : ''),
                    createElement("div", { className: "error-btn", onClick: () => this.btnClick() },
                        createElement("span", null, buttonText),
                        createElement("span", { className: "count-down-tips" }, this.state.countdowning ? timeTipText : '')))));
        }
        return (createElement("div", { className: wrapCls },
            createElement(InputItem, Object.assign({ isReg: this.props.isReg, type: type === 'number' ? 'number' : 'text', placeholder: placeholder, title: title, titleWidth: titleWidth, textStyle: textStyle, maxLength: maxLength, clear: true, inputStyle: attributeMap.inputStyle, inputAriaLabel: inputAriaLabel, isTitleUp: isTitleUp, error: error, extra: type === 'number' ? (createElement("div", { className: buttonCls },
                    createElement("span", null, buttonText),
                    this.state.countdowning ? 's' : '')) : (createElement("div", { className: rightImgCls }, rightComponent ? (createElement("img", { src: rightComponent, style: { width: rightConponentWidth } })) : null)), onExtraClick: () => this.btnClick(), disabled: disabled }, restProps)),
            tips ? createElement("div", { className: `${prefixCls}-tips`, role: 'text', "aria-label": tipsAriaLabel },
                " ",
                tips) : null));
    }
}
VerifyCode.defaultProps = {
    prefixCls: 'im-verifycode',
    title: '请输入验证码',
    placeholder: '',
    hideBottomLine: true,
    type: 'number',
    buttonText: '获取',
    rightButtonText: '重新获取',
    maxLength: 6,
    time: 60,
    auto: false,
    rightConponentWidth: '70px',
    timeTipText: '秒后重新获取',
    errorInfo: '验证码错误，请重新输入',
    showErrorInfo: false,
    keyboardType: 'alert',
    isReg: true,
    autoCountDown: true,
    isTitleUp: false
};
export { VerifyCodePropsType };
export default VerifyCode;
